import React from "react";

import {
  Divider,
  Grid,
  Typography,
  Accordion,
  TextField,
  MenuItem,
  AccordionSummary,
  AccordionDetails,
  Button
} from "@material-ui/core";

import InfoTooltip from "../../general/InfoTooltip";
import CustomerPortalDialog from "../tools/CustomerPortalDialog";

import InfoIcon from '@material-ui/icons/Info';

export default function CreditFieldGroupPersonTipp(
  {
    renderCreditField,
    creditFunctions,
    createPortal,
    savePortal,
    portals,
    index,
    credit_id,
    metafields,
    setMetafields,
  }) {



  return (
    <>
      <Grid item xs={12} md={12}>
        <Divider />
      </Grid>
      {renderCreditField("__person" + index + "__anrede", 6, 2)}
      {renderCreditField("__person" + index + "__vorname", 6, 5)}
      {renderCreditField("__person" + index + "__nachname", 6, 5)}
      {renderCreditField("__person" + index + "__postleitzahl", 4, 2)}
      {renderCreditField("__person" + index + "__ort", 8, 4)}
      {renderCreditField("__person" + index + "__strasse", 8, 4)}
      {renderCreditField("__person" + index + "__hausnummer", 4, 2)}
      {renderCreditField("__person" + index + "__kontakt_mobil", 6, 4)}
      {renderCreditField("__person" + index + "__kontakt_email", 6, 4)}
      <Grid item xs={12} md={4}>
        <CustomerPortalDialog
          personIndex={index}
          creditFunctions={creditFunctions}
          createPortal={createPortal}
          savePortal={savePortal}
          portals={portals}
          credit_id={credit_id}
          metafields={metafields}
          setMetafields={setMetafields}
        />
      </Grid>
    </>
  );
}
